var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page photo_book_page_list_item portrait container",on:{"click":function($event){return _vm.$emit('pageselected', _vm.num)}}},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_c('div',{staticClass:"tag"},[_vm._v(_vm._s(_vm.num))]),_c('b-img-lazy',{staticClass:"book_page_image",attrs:{"src":_vm.url,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }